import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "SjPrivacyPolicy2"
});
const _hoisted_1 = {
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M3.32129 2.26396H12.678C12.8437 2.26396 12.978 2.39828 12.978 2.56396V14.3293L8.5996 11.8018C8.22835 11.5875 7.77098 11.5875 7.39973 11.8018L3.02129 14.3293V2.56397C3.02129 2.39828 3.1556 2.26396 3.32129 2.26396Z",
  stroke: "#5587FF",
  "stroke-width": "1.4"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  d: "M7.72261 4.40654C7.82544 4.1611 8.17318 4.1611 8.27601 4.40654L8.77597 5.5999C8.81871 5.7019 8.9141 5.77212 9.0242 5.78262L10.2971 5.90397C10.5568 5.92873 10.6633 6.25039 10.4697 6.42527L9.49758 7.30305C9.41763 7.37524 9.38253 7.48474 9.4056 7.58996L9.68809 8.87834C9.74467 9.13637 9.46424 9.33629 9.23876 9.19866L8.1556 8.53756C8.05964 8.47899 7.93898 8.47899 7.84302 8.53756L6.75986 9.19866C6.53437 9.33629 6.25395 9.13637 6.31053 8.87834L6.59302 7.58996C6.61609 7.48474 6.58098 7.37524 6.50104 7.30305L5.52896 6.42527C5.3353 6.25039 5.44179 5.92873 5.70155 5.90397L6.97442 5.78262C7.08452 5.77212 7.17991 5.7019 7.22265 5.5999L7.72261 4.40654Z",
  fill: "#7FA5FF"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var SJ_Privacy_Policy2 = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { SJ_Privacy_Policy2 as default };
